import { getDynamicWcMetadata, getPendingDynamicWcMetadata } from "@layerswap/wallet-core";
import { evmConnectorNameResolver, resolveEVMWalletConnectorIcon } from '../evmUtils';
import { EIP155_NAMESPACE, HIDDEN_WALLETCONNECT_ID, immutableZKEvm } from '../constants';
import { findEthereumNetwork } from './findEthereumNetwork';
import { resolveSupportedNetworks } from './resolveSupportedNetworks';
export function resolveWallet(props) {
    const { activeConnection, connection, networks, networkAdapter, ethereumChainIds, disconnect, supportedNetworks, providerName, } = props;
    const walletIsActive = activeConnection?.id === connection?.connector.id;
    const addresses = connection?.accounts;
    const activeAddress = activeConnection?.address;
    const connector = connection?.connector;
    if (!connector)
        return undefined;
    const address = walletIsActive ? activeAddress : addresses?.[0];
    if (!address)
        return undefined;
    const isHiddenConnector = connector.id === HIDDEN_WALLETCONNECT_ID;
    const dynamicMetadata = isHiddenConnector
        ? (getPendingDynamicWcMetadata(EIP155_NAMESPACE) || getDynamicWcMetadata(EIP155_NAMESPACE, address))
        : null;
    const walletName = dynamicMetadata?.name || connector.name;
    const walletId = dynamicMetadata?.id || connector.id;
    const walletIcon = dynamicMetadata?.icon || connector.icon;
    const walletDisplayName = `${walletName} ${walletId === 'com.immutable.passport' ? '' : ' - EVM'}`;
    const iconNetwork = walletId === 'com.immutable.passport'
        ? networks.find(network => immutableZKEvm.some(name => name === networkAdapter.getId(network)))
        : findEthereumNetwork(networks, networkAdapter, ethereumChainIds);
    return {
        chainId: connection?.chainId,
        id: walletName,
        internalId: walletId,
        isActive: walletIsActive,
        address,
        addresses: addresses || [address],
        displayName: walletDisplayName,
        providerName,
        icon: resolveEVMWalletConnectorIcon({ connector: evmConnectorNameResolver(connector), iconUrl: walletIcon }),
        disconnect: () => disconnect(connector.name),
        asSourceSupportedNetworks: resolveSupportedNetworks(supportedNetworks.asSource, walletId),
        autofillSupportedNetworks: resolveSupportedNetworks(supportedNetworks.autofill, walletId),
        withdrawalSupportedNetworks: resolveSupportedNetworks(supportedNetworks.withdrawal, walletId),
        networkIcon: iconNetwork ? networkAdapter.getIcon(iconNetwork) : undefined,
        metadata: {
            connectorId: connector.id,
            connectorUid: connector.uid,
            deepLink: dynamicMetadata?.deepLink || connector.deepLink,
            evmConnectorUid: connector.uid,
            walletConnectTopic: connector.getSessionTopic?.(),
        },
    };
}
